module.exports = __webpack_public_path__ + "static/media/git.0cb24c28.svg";